enum LocalStorageKey {
  TourCriteria = 'tourCriteria',
  TourCriteriaTury = 'tourCriteria/tury',
  TourCriteriaHotelOffers = 'tourCriteria__hotelOffers',
  TourCriteriaRailwayTours = 'tourCriteria__railwayTours',
}

export { LocalStorageKey };
